import type { ExternalListingStatus, Platform } from '@/types'

// gRPC enum values can arrive as either their numeric index or their string constant
// name depending on serialization — normalize both forms to the clean union type.
export const PLATFORM_NORM: Record<string | number, Platform> = {
	1: 'AVITO', INTEGRATION_PLATFORM_AVITO: 'AVITO',
	2: 'CIAN',  INTEGRATION_PLATFORM_CIAN: 'CIAN',
	3: 'SITE',  INTEGRATION_PLATFORM_SITE: 'SITE',
}

export const STATUS_NORM: Record<string | number, ExternalListingStatus> = {
	0: 'UNPUBLISHED', EXTERNAL_LISTING_STATUS_UNSPECIFIED: 'UNPUBLISHED',
	1: 'UNPUBLISHED', EXTERNAL_LISTING_STATUS_UNPUBLISHED: 'UNPUBLISHED',
	2: 'MODERATION',  EXTERNAL_LISTING_STATUS_MODERATION: 'MODERATION',
	3: 'PUBLISHED',   EXTERNAL_LISTING_STATUS_PUBLISHED: 'PUBLISHED',
	4: 'PAUSED',      EXTERNAL_LISTING_STATUS_PAUSED: 'PAUSED',
	5: 'ERROR',       EXTERNAL_LISTING_STATUS_ERROR: 'ERROR',
}

export function normalizeListingStatus(status: string | number): ExternalListingStatus {
	return STATUS_NORM[status] ?? (status as ExternalListingStatus)
}

export function normalizeListingPlatform(platform: string | number): Platform {
	return PLATFORM_NORM[platform] ?? (platform as Platform)
}

/**
 * A listing counts as "the property is published" once it has been submitted
 * (MODERATION) or has gone live (PUBLISHED) or was live and is temporarily
 * PAUSED — as opposed to UNPUBLISHED (never submitted) or ERROR (submission failed).
 */
const PUBLISHED_LIKE_STATUSES: ReadonlySet<ExternalListingStatus> = new Set(['PUBLISHED', 'MODERATION', 'PAUSED'])

export function isPublishedLikeStatus(status: string | number): boolean {
	return PUBLISHED_LIKE_STATUSES.has(normalizeListingStatus(status))
}
